export default __webpack_public_path__ + "static/UE-c7a3e9381aac46629412ba6cb1d51207.png";